"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostItem = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const post_styles_1 = require("@/components/domains/post/post.styles");
const shared_styles_1 = require("@/stylesheets/shared.styles");
require("@/components/common");
/**
 * 블로그 글 목록의 카드 한 장. 정사각 썸네일 아래에 제목을 두고, 분류와 날짜를 메타 한 줄로 붙인다.
 * href가 있으면 카드 전체가 링크가 되고 hover 배경을 표시한다.
 */
let PostItem = class PostItem extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.href = '';
        this.thumbnail = '';
        this.title = '';
        this.category = '';
        this.date = '';
    }
    render() {
        const body = (0, lit_1.html) `
      <mm-thumbnail src=${this.thumbnail} ratio="1:1"></mm-thumbnail>
      <mm-heading level="3">${this.title}</mm-heading>
      <mm-meta-item-group gap="3">
        <mm-text>${this.category}</mm-text>
        <mm-text as="time" color="light">${this.date}</mm-text>
      </mm-meta-item-group>
    `;
        if (!this.href) {
            return (0, lit_1.html) `
        <div class="link">${body}</div>
      `;
        }
        return (0, lit_1.html) `
      <a class="link" href=${this.href}>${body}</a>
    `;
    }
};
PostItem.styles = [
    shared_styles_1.resetStyles,
    post_styles_1.postLinkStyles,
    (0, lit_1.css) `
      :host {
        display: block;
      }

      .link {
        flex-direction: column;
        gap: var(--space-4);
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PostItem.prototype, "href", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PostItem.prototype, "thumbnail", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PostItem.prototype, "title", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PostItem.prototype, "category", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PostItem.prototype, "date", void 0);
PostItem = __decorate([
    (0, decorators_js_1.customElement)('mm-post-item')
], PostItem);
exports.PostItem = PostItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9zdC1pdGVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicG9zdC1pdGVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFFM0QsdUVBQXNFO0FBQ3RFLCtEQUF5RDtBQUN6RCwrQkFBNEI7QUFFNUI7OztHQUdHO0FBRUksSUFBTSxRQUFRLEdBQWQsTUFBTSxRQUFTLFNBQVEsZ0JBQVU7SUFBakM7O1FBZXVCLFNBQUksR0FBRyxFQUFFLENBQUE7UUFDVCxjQUFTLEdBQUcsRUFBRSxDQUFBO1FBQ2QsVUFBSyxHQUFHLEVBQUUsQ0FBQTtRQUNWLGFBQVEsR0FBRyxFQUFFLENBQUE7UUFDYixTQUFJLEdBQUcsRUFBRSxDQUFBO0lBc0J2QyxDQUFDO0lBcEJDLE1BQU07UUFDSixNQUFNLElBQUksR0FBRyxJQUFBLFVBQUksRUFBQTswQkFDSyxJQUFJLENBQUMsU0FBUzs4QkFDVixJQUFJLENBQUMsS0FBSzs7bUJBRXJCLElBQUksQ0FBQyxRQUFROzJDQUNXLElBQUksQ0FBQyxJQUFJOztLQUUvQyxDQUFBO1FBRUQsSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLEVBQUU7WUFDZCxPQUFPLElBQUEsVUFBSSxFQUFBOzRCQUNXLElBQUk7T0FDekIsQ0FBQTtTQUNGO1FBRUQsT0FBTyxJQUFBLFVBQUksRUFBQTs2QkFDYyxJQUFJLENBQUMsSUFBSSxJQUFJLElBQUk7S0FDekMsQ0FBQTtJQUNILENBQUM7O0FBdkNNLGVBQU0sR0FBRztJQUNkLDJCQUFXO0lBQ1gsNEJBQWM7SUFDZCxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7O0tBU0Y7Q0FDRixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztzQ0FBVTtBQUNUO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzsyQ0FBZTtBQUNkO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzt1Q0FBVztBQUNWO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzswQ0FBYztBQUNiO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztzQ0FBVTtBQW5CMUIsUUFBUTtJQURwQixJQUFBLDZCQUFhLEVBQUMsY0FBYyxDQUFDO0dBQ2pCLFFBQVEsQ0F5Q3BCO0FBekNZLDRCQUFRIn0=